// DS: i7.14
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const EditorItalic: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <path
          fillRule="evenodd"
          d="M9 6a1 1 0 001 1.001h1.713l-1.592 10H8.999A1 1 0 009 19h5.002a1 1 0 000-1.999h-1.854l1.591-10H15a1 1 0 00.993-.883L16 6a1 1 0 00-1-1h-5a1 1 0 00-1 1z"
          clipRule="evenodd"
        ></path>
      </svg>
    </IconWrap>
  );
};
EditorItalic.displayName = 'EditorItalic';

export default EditorItalic;
